import React from 'react';
import {Button, Col, Row} from "react-bootstrap";
import styles from "./transfer-authorization.module.scss";
import {DropDown, FormGroup, InputGroup, RadioButton, TextInput} from "../../../../../components/form/form";
import {
  getGraduatedTaxStatusTypes,
  getNonStockProfitTypes,
  getTaxStatusTypes, getToTypes
} from "../../../../../helpr/transferFormData";
import {useValidation} from "../../../../../hooks/use-validation";
import {
  authorizationObj,
  authorizationValidator,
} from "../../../../../form-control/transfer-form/transfer-form-control";

const TransferAuthorization = ({context, controls}) => {
  //Unpack transfer form main context
  const { transferFormState, setTransferFormState } = context;
  const {next, back} = controls;

  //Setup validator and transfer instruction state
  const transferAuthorizationState = useValidation(
    authorizationValidator,
    authorizationObj(transferFormState),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getRadioButtonProps, getDropdownProps } = transferAuthorizationState;

  const nextPage = () => {
    const { formState, isFormValid } = validate();
    if(isFormValid){
      setTransferFormState({
        ...transferFormState,
        ...formState
      });
      next();
    }
  }
  return (
    <div className={styles['form-section']} >
      <Row>
        <Col lg={12}>
          <FormGroup header={'AUTHORIZATION'}>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                  <span className={styles['sub-label']}>
                    I/We hereby authorize and instruct PDTC to transfer the security in relation to a trade with abovementioned details:
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                  From (Existing Location):
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <TextInput inputProps={getTextFieldProps('fromRegistryBpId')} placeholder={""}>
                  Registry BP ID:*
                </TextInput>
              </Col>
              <Col lg={4}>
                <TextInput inputProps={getTextFieldProps('fromRegistryAccountNumber')} placeholder={""}>
                  Account Number:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <DropDown inputProps={getDropdownProps('toType')} values={getToTypes()}>
                  To (Destination/Settlement Location):*
                </DropDown>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <TextInput inputProps={getTextFieldProps('toDepositoryBpId')} placeholder={""}>
                  Depository BP ID:*
                </TextInput>
              </Col>
              <Col lg={4}>
                <TextInput inputProps={getTextFieldProps('toDepositoryAccountNumber')} placeholder={""}>
                  Account Number:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <TextInput inputProps={getTextFieldProps('toRegistryBpId')} placeholder={""}>
                  Registry BP ID:*
                </TextInput>
              </Col>
              <Col lg={4}>
                <TextInput inputProps={getTextFieldProps('toRegistryAccountNumber')} placeholder={""}>
                  Registry Account Number:*
                </TextInput>
              </Col>
            </Row>
          </FormGroup>
        </Col>
        <Col lg={12}>
          <div className={styles['input-group-section']}>
            <InputGroup header={<>NON-STOCK AND NON-PROFIT <span className={styles['sub-label']}>(for Corporation claiming tax-exemption)</span>:*</>}>
              <RadioButton inputProps={getRadioButtonProps('nonStockProfit')}
                           data={getNonStockProfitTypes()} othersOption={false}>
              </RadioButton>
            </InputGroup>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['input-group-section']}>
            <InputGroup header={"TAX STATUS:*"}>
              <RadioButton inputProps={getRadioButtonProps('toTaxStatus')}
                           data={getTaxStatusTypes()} othersOption={true}>
              </RadioButton>
            </InputGroup>
          </div>
        </Col>
        <Col lg={6}>
          <div className={styles['input-group-section']}>
            <InputGroup header={<>GRADUATED TAX STATUS <span className={styles['sub-label']}>(for Bank Issues only)</span>:</>}>
              <RadioButton inputProps={getRadioButtonProps('toGraduatedTaxStatus')}
                           data={getGraduatedTaxStatusTypes()} othersOption={false}>
              </RadioButton>
            </InputGroup>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['back-button']}>
            <Button variant="secondary" onClick={() => back()}>
              BACK
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['next-button']}>
            <Button onClick={() => nextPage()}>
              NEXT
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default TransferAuthorization;
